import { RefObject } from "react";

export type RequiredField = {
  label: string;
  value: unknown;
  elementId?: string;
  ref?: RefObject<HTMLElement | null>;
};

export type MissingRequiredField = RequiredField;

const isMissing = (value: unknown): boolean => {
  if (value === null || value === undefined) return true;
  if (typeof value === "string") return value.trim() === "";
  if (Array.isArray(value)) return value.length === 0;
  return false;
};

export const findMissingRequiredFields = (fields: RequiredField[]): MissingRequiredField[] => {
  return fields.filter((field) => isMissing(field.value));
};

export const formatRequiredMessage = (missingFields: MissingRequiredField[]): string => {
  const labels = missingFields.map((field) => field.label);
  return `필수 입력 필요: ${labels.join(", ")}`;
};

export const focusFirstMissingField = (missingFields: MissingRequiredField[]): void => {
  if (!missingFields.length) return;

  const first = missingFields[0];
  const targetElement = first.ref?.current ?? (first.elementId ? document.getElementById(first.elementId) : null);

  if (!targetElement) return;

  targetElement.scrollIntoView({ behavior: "smooth", block: "center" });
  if ("focus" in targetElement && typeof targetElement.focus === "function") {
    targetElement.focus();
  }
};
